import React, { useState } from "react";
import I18n from "i18n-js";

import { nomenclatureDesignationFromUuid } from "../../../../nomenclatures/utils/nomenclatureUtils";
import { formatDate } from "../../../../common/utils/dateUtils";
import StatelessTable from "../../../../common/components/elements/StatelessTable";
import { shape } from "prop-types";

InstallationComponentListView.propTypes = {
  components: shape(),
  nomenclaturesList: shape(),
};

export default function InstallationComponentListView({
  components,
  nomenclaturesList,
}) {
  const {
    componentBrands,
    componentNatureClassifications,
    componentNatureTypes,
    componentNatures,
  } = nomenclaturesList;

  const [currentPage, setCurrentPage] = useState(1);

  function dataTableHead() {
    return [
      I18n.t("pages.installations.view.components.nature:label"),
      I18n.t("pages.installations.view.components.type:label"),
      I18n.t("pages.installations.view.components.category:label"),
      I18n.t("pages.installations.view.components.brand:label"),
      I18n.t("pages.installations.view.components.model:label"),
      I18n.t("pages.installations.view.components.serial-number:label"),
      I18n.t("pages.installations.view.components.mark:label"),
      I18n.t("pages.installations.view.components.designation:label"),
      I18n.t("pages.installations.view.components.barcode:label"),
      I18n.t("pages.installations.view.components.commissioning-date:label"),
      I18n.t("pages.installations.view.components.usage-percent:label"),
    ];
  }

  function dataTableRow(rowData) {
    const {
      nature,
      natureType,
      natureClassification,
      brand,
      model,
      serialNumber,
      mark,
      designation,
      barcode,
      commissioningDate,
      usagePercent,
    } = rowData;
    return [
      nomenclatureDesignationFromUuid(componentNatures, nature),
      nomenclatureDesignationFromUuid(componentNatureTypes, natureType),
      nomenclatureDesignationFromUuid(
        componentNatureClassifications,
        natureClassification
      ),
      nomenclatureDesignationFromUuid(componentBrands, brand),
      model,
      serialNumber,
      mark,
      designation,
      barcode,
      formatDate(commissioningDate),
      (usagePercent ?? "0") + "%",
    ];
  }

  return (
    <StatelessTable
      className=""
      data={components}
      pagination={true}
      perPage={5}
      currentPage={currentPage}
      onPageChanged={(newPage) => {
        setCurrentPage(newPage);
      }}
      headData={dataTableHead()}
      rowData={(data) => dataTableRow(data)}
    />
  );
}
